const buttonBase = {
  disableRipple: true,
};

export default buttonBase;
